import { render } from "./SSDBalancesView.vue?vue&type=template&id=5595a40c&scoped=true"
import script from "./SSDBalancesView.vue?vue&type=script&lang=js"
export * from "./SSDBalancesView.vue?vue&type=script&lang=js"

import "./SSDBalancesView.vue?vue&type=style&index=0&id=5595a40c&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5595a40c"]])

export default __exports__